import { useAuth } from "react-oidc-context";
import styled from "styled-components";
import Lottie from "lottie-react";
import { FcGoogle } from "react-icons/fc";
import adminAnimation from "../assets/lottie/admin-car.json";
import { Card, SecondaryButton } from "../components/ui";
import Logo from "../components/Logo";

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.space(6)};
  background:
    radial-gradient(60% 50% at 80% 0%, ${({ theme }) => theme.colors.accentSoft} 0%, transparent 60%),
    radial-gradient(50% 40% at 0% 100%, #EFE6D9 0%, transparent 60%),
    ${({ theme }) => theme.colors.bg};
`;

const Panel = styled(Card)`
  width: 100%;
  max-width: 460px;
  padding: ${({ theme }) => theme.space(8)};
  text-align: center;
  box-shadow: ${({ theme }) => theme.shadow.lg};

  ${({ theme }) => theme.media.sm} {
    padding: ${({ theme }) => theme.space(6)};
  }
`;

const Heading = styled.h1`
  font-family: ${({ theme }) => theme.fonts.serif};
  font-weight: 400;
  font-size: 34px;
  letter-spacing: -0.02em;
  margin-top: ${({ theme }) => theme.space(2)};
`;

const Sub = styled.p`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 15px;
  margin-top: ${({ theme }) => theme.space(2)};
  margin-bottom: ${({ theme }) => theme.space(6)};
`;

const GoogleButton = styled(SecondaryButton)`
  width: 100%;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 600;
  svg { width: 20px; height: 20px; }
`;

const Footer = styled.div`
  margin-top: ${({ theme }) => theme.space(6)};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSubtle};
`;

const Hero = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.space(2)};

  & > * { width: 100% !important; max-width: 260px; height: auto !important; }
`;

function Home() {
  const auth = useAuth();

  return (
    <Page>
      <Panel>
        <Hero>
          <Lottie animationData={adminAnimation} loop />
        </Hero>
        <Logo size={20} />
        <Heading>Welcome back</Heading>
        <Sub>Sign in to manage sites, bays and customers across the Carparky network.</Sub>
        <GoogleButton onClick={() => auth.signinRedirect()}>
          <FcGoogle /> Sign in with Google
        </GoogleButton>
        <Footer>Restricted to authorized administrators.</Footer>
      </Panel>
    </Page>
  );
}

export default Home;
